<template>
  <tabs parent="notification">

    <tab
      id="device_notification"
      :name="translate('notification.dev_notify')"
      :href="url+'/device_notification'"
    >
      <DeviceNotification />
    </tab>

    <tab
        id="traffic_notification"
        :name="translate('notification.traffic_notify')"
        :href="url+'/traffic_notification'"
        :isVisible="this.$store.getters.getPermissions.permissionGod === true"
    >
      <TrafficNotification />
    </tab>

    <tab
      id="channels_notification"
      :name="translate('notification.channels_notify')"
      :href="url+'/channels_notification'"
    >
      <ChannelsNotification />
    </tab>
    <tab
        id="telegram_destinations"
        :name="translate('telegram.destinations_title')"
        :href="url+'/telegram_destinations'"
        :isVisible="$store.getters.getPermissions.permissionGod === true"
    >
      <TelegramDestinations />
    </tab>
    <tab
        id="notification_routes"
        :name="translate('telegram.routes_title')"
        :href="url+'/notification_routes'"
        :isVisible="$store.getters.getPermissions.permissionGod === true"
    >
      <NotificationRoutes />
    </tab>
  </tabs>
</template>

<script>
import TelegramDestinations from './Tabs/TelegramDestinations/Index.vue'
import NotificationRoutes from './Tabs/NotificationRoutes/Index.vue'
import ChannelsNotification from './Tabs/ChannelsNotification/Index.vue'
import DeviceNotification from "./Tabs/DeviceNotification/Index.vue";
import TrafficNotification from "./Tabs/TrafficNotification/Index.vue";

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Notifications',
  components: {
    Tabs,
    Tab,
    TelegramDestinations,
    NotificationRoutes,
    ChannelsNotification,
    DeviceNotification,
    TrafficNotification
  },
  computed: {
    url () { return '/notification' }
  },
  created() {
    this.redirect()
  },
  activated() {
    this.redirect()
  },
  methods:{
    redirect(){
      if (this.$route.name === "notification"){
        if (this.$store.getters.getPermissions.permissionGod === true) {
          this.$router.push("/notification/traffic_notification")
        }else{
          this.$router.push("/notification/device_notification")
        }
      }
    }
  }
}
</script>
